import { Link } from "react-router-dom";
import { faqs } from "@/mocks/siteData";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-3xl mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="关于本站的常见问题"
          desc="收录范围、信息来源和反馈方式，都在这里说明清楚。"
          align="center"
        />
        <FaqAccordion items={faqs.slice(0, 4)} />
        <div className="mt-8 text-center">
          <Link
            to="/faq"
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-foreground-950 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            查看全部问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}